import { Component } from '@angular/core';

@Component({
  selector: 'app-url-incorrecta',
  templateUrl: './url-incorrecta.component.html',
  host: {
    class:
      'd-flex flex-grow-1 align-items-center ' +
      'justify-content-center bg-white',
  },
})
export class UrlIncorrectaComponent {}
